import React, { Component } from "react";
import moment from "moment";
import TextareaField from "./form/TextareaField";
import TextField from "./form/TextField";
import CheckboxField from "./form/CheckboxField";
import PropTypes from "prop-types";
import classNames from "classnames";
import Tooltip from "@material-ui/core/Tooltip";
import db from "../../api/db";
import Persontags from "./Persontags";

class Person extends Component {
  _isMounted = false;

  static propTypes = {
    onChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      person: [],
      title: this.props.Person.title,
      alias: this.props.Person.alias,
      comment: this.props.Person.comment,
      famous_person: this.props.Person.famous,
      nomention: this.props.Person.nomention,
      mentioned: this.props.Person.mentioned,
      glory_person: this.props.Person.glory,
      sport_person: this.props.Person.sport,
      achievements_nb:
        this.props.Person.achievements && this.props.Person.achievements.nb
          ? this.props.Person.achievements.nb
          : "",
      tags_nb:
        this.props.Person.tags && this.props.Person.tags.nb
          ? this.props.Person.tags.nb
          : "",
      bio_nb:
        this.props.Person.bio && this.props.Person.bio.nb
          ? this.props.Person.bio.nb
          : "",
      disabled: false,
      loading: true,
      image:
        typeof this.props.Person.images == "undefined"
          ? false
          : this.props.Person.images,
      image_button: "Last opp bilde",
      error: false,
      imagesearch: false,
      change_glory: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getSingledoc = this.getSingledoc.bind(this);
  }

  componentWillReceiveProps(props) {
    if (props.Active) {
      this.getSingledoc(props.Person.id);
    }
  }

  componentDidMount() {
    this._isMounted = true;

    this.setState({
      loading: false,
      person: this.props.Person
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState({
      imagesearch: false
    });
  }

  getSingledoc(id = this.state.person.id) {
    db.get("person", id).then(response => {
      if (this._isMounted) {
        const person = response.data;
        this.setState({
          disabled: false,
          person: person,
          title: person.title,
          alias: person.alias,
          comment: person.comment,
          famous_person:
            typeof person.famous == "undefined" ? false : person.famous,
          nomention:
            typeof person.nomention == "undefined" ? false : person.nomention,
          sport_person:
            typeof person.sport == "undefined" ? false : person.sport,
          glory_person:
            typeof person.glory == "undefined" ? false : person.glory,
          tags_nb: person.tags && person.tags.nb ? person.tags.nb : "",
          bio_nb: person.bio && person.bio.nb ? person.bio.nb : "",
          achievements_nb:
            person.achievements && person.achievements.nb
              ? person.achievements.nb
              : "",
          image: person.images ? person.images : []
        });
      }
    });
  }

  transformGender(gender) {
    if (gender === "Female") {
      return "Kvinne";
    } else if (gender === "Male") {
      return "Mann";
    }
    return "Ukjent kjønn";
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "glory_person") {
      this.setState({
        change_glory: true
      });
    }

    this.setState({
      [name]: value
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    let person = this.state.person;

    this.setState({
      disabled: true
    });

    const params = {
      comment: this.state.comment,
      title: this.state.title,
      alias: this.state.alias,
      famous: this.state.famous_person,
      nomention: this.state.nomention,
      mentioned: this.state.mentioned,
      sport: this.state.sport_person,
      glory: this.state.glory_person,
      id: person.id ? person.id : this.props.Person.id,
      update_local: moment().format(),
      tags: {
        nb: this.state.tags_nb,
        de: "",
        en: ""
      },
      bio: {
        nb: this.state.bio_nb,
        de: "",
        en: ""
      },
      achievements: {
        nb: this.state.achievements_nb,
        de: "",
        en: ""
      },
      _change: {
        glory: this.state.change_glory
      }
    };

    db.patch("person", params)
      .then(res => {
        this.props.onChange(person.id);
        const upperson = res.data;

        this.setState({
          disabled: false,
          person: upperson,
          title: upperson.title,
          alias: upperson.alias,
          comment: upperson.comment,
          famous_person:
            typeof upperson.famous == "undefined" ? false : upperson.famous,
          nomention:
            typeof upperson.nomention == "undefined"
              ? false
              : upperson.nomention,
          mentioned:
            typeof upperson.mentioned == "undefined"
              ? false
              : upperson.mentioned,
          sport_person:
            typeof upperson.sport == "undefined" ? false : upperson.sport,
          glory_person:
            typeof upperson.glory == "undefined" ? false : upperson.glory,
          achievements_nb:
            this.props.Person.achievements && this.props.Person.achievements.nb
              ? this.props.Person.achievements.nb
              : "",
          bio_nb:
            this.props.Person.bio && this.props.Person.bio.nb
              ? this.props.Person.bio.nb
              : "",
          tags_nb:
            this.props.Person.tags && this.props.Person.tags.nb
              ? this.props.Person.tags.nb
              : ""
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    let person = this.state.person.length
      ? this.state.person
      : this.props.Person;

    new Intl.NumberFormat("no-NO", {
      style: "currency",
      currency: "NOK",
      maximumSignificantDigits: 2
    });

    let expanded;

    const birthday = moment(person.birthdate).format("MM-DD");
    var curyear = moment().format("YYYY");

    if (moment(curyear + "-" + birthday).diff(moment(), "days") < 0) {
      curyear = moment().add(1, "years").format("YYYY");
    }

    const jubage = moment(curyear + "-" + birthday).diff(
      person.birthdate,
      "years"
    );
    const jubdate = moment(curyear + "-" + birthday).format("DD.MM.YYYY");

    if (this.props.Active) {
      expanded = (
        <tr
          className={classNames("modal-open", {
            fleng: this.state.person.fleng
          })}
        >
          <td colSpan="1"></td>
          <td colSpan="2">
            <div className="col1 grid-y shrink">
              <div className="metainfo">
                <div className="name">
                  {person.firstname} {person.middlename} {person.lastname}
                </div>
                <div className="adress">
                  {person.address}
                  <br />
                  {person.postalcode} {person.city}
                  <br />
                </div>
                <div className="gender">
                  {this.transformGender(person.gender)}
                </div>
                <div className="status">
                  {person.code === 5 ? (
                    <div className="birth">
                      Død{" "}
                      {person.deceasedDate
                        ? `(${moment(person.deceasedDate).format(
                            "DD.MM.YYYY"
                          )})`
                        : ""}
                    </div>
                  ) : (
                    <div className="birth">
                      <span>Fyller {jubage} år,</span> {jubdate}
                    </div>
                  )}
                </div>
                <div className="metadata">
                  {person.id}
                  <br />
                  {this.state.person.fleng ? "Opprettet av NTB" : ""}
                  {person.update_df
                    ? `Opp. DF: ${moment(person.update_df).format(
                        "DD.MM.YY - HH:MM"
                      )}`
                    : ""}
                  <br />
                  {person.update_local
                    ? `Opp. NTB: ${moment(person.update_local).format(
                        "DD.MM.YY - HH:MM"
                      )}`
                    : ""}
                </div>
              </div>
              <div className="actions">
                <div className="grid-x">
                  <div className="cell auto">
                    <button
                      className="button expanded"
                      onClick={e => this.handleSubmit(e)}
                    >
                      {this.state.disabled ? "Lagrer..." : "Lagre og lukk"}
                    </button>
                  </div>
                  <div className="cell shrink">
                    <button
                      className="button link"
                      onClick={e => this.props.onChange(person.id)}
                    >
                      Lukk
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td colSpan="7">
            <div className="col2">
              <TextField
                className="white-input"
                name="title"
                value={this.state.title}
                label="Tittel"
                onChange={this.handleChange}
              />
              <TextField
                className="white-input"
                name="alias"
                value={this.state.alias}
                label="Kallenavn / alias"
                onChange={this.handleChange}
              />
              <TextareaField
                className="white-input"
                name="comment"
                value={this.state.comment}
                label="Kommentar"
                onChange={this.handleChange}
              />
              {this.state.glory_person ? (
                <React.Fragment>
                  <TextareaField
                    className="white-input"
                    name="bio_nb"
                    value={this.state.bio_nb}
                    label="Biografi"
                    onChange={this.handleChange}
                  />
                  <TextareaField
                    className="white-input"
                    name="achievements_nb"
                    value={this.state.achievements_nb}
                    label="Utmerkelser"
                    onChange={this.handleChange}
                  />
                  <TextField
                    className="white-input"
                    name="tags_nb"
                    label="Tags (ord separert med komma)"
                    value={
                      typeof this.state.tags_nb === "string"
                        ? this.state.tags_nb
                        : ""
                    }
                    onChange={this.handleChange}
                  />
                </React.Fragment>
              ) : (
                ""
              )}
              <div className="grid-x">
                <CheckboxField
                  name="famous_person"
                  value={this.state.famous_person}
                  label="Kjent"
                  onChange={this.handleChange}
                />
                <CheckboxField
                  name="mentioned"
                  value={this.state.mentioned}
                  label="Viktig"
                  onChange={this.handleChange}
                />
                <CheckboxField
                  name="sport_person"
                  value={this.state.sport_person}
                  label="Idrettsprofil"
                  onChange={this.handleChange}
                />
                <CheckboxField
                  name="glory_person"
                  value={this.state.glory_person}
                  label="Æresgalleri"
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </td>
          <td className="pic">
            <div></div>
          </td>
          <td className="action">
            <CheckboxField
              inverted={true}
              name="nomention"
              value={this.state.nomention}
              onChange={this.handleChange}
              tooltip="Huk vekk hvis personen ikke ønsker omtale"
            />
          </td>
          <td></td>
        </tr>
      );
    }

    if (this.state.error) {
      return (
        <React.Fragment>
          <tr className="spacer"></tr>
          <tr className="error">
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <tr className="spacer"></tr>
        <tr
          onClick={e => this.props.onChange(person.id)}
          data-index={this.props.index}
          data-id={person.id}
          data-score={Math.round(person._score)}
          className={classNames(this.props.Row, {
            open: this.props.Active,
            loading: this.state.loading,
            dead: this.state.person.code === 5,
            marked: this.props.inList,
            fleng: this.state.person.fleng
          })}
        >
          <td>
            {this.props.selectBox ? (
              <div>
                <input
                  type="checkbox"
                  disabled={
                    this.props.inList ||
                    this.state.nomention ||
                    person.code === 5
                  }
                  className="alt"
                  id={"alt_" + person.id}
                  name={person.id}
                  checked={this.props.selected}
                  onChange={e => this.props.selectedPersons(person.id)}
                />
                <label htmlFor={"alt_" + person.id}></label>
              </div>
            ) : (
              <span>{Math.round(person._score)}</span>
            )}
          </td>
          <td className="cutter">
            {person.firstname} {person.middlename}
          </td>
          <td className="cutter">{person.lastname}</td>
          <td className="cutter">{person.address}</td>
          <td>{person.postalcode}</td>
          <td>{person.city}</td>
          <td>{moment(person.birthdate).format("DD.MM.YYYY")}</td>
          <td>
            {person.deceasedDate
              ? moment(person.deceasedDate).diff(person.birthdate, "years")
              : moment().diff(person.birthdate, "years")}
          </td>
          <td className="num">
            {person.income ? Intl.NumberFormat().format(person.income) : "-"}
          </td>
          <td className="num">
            {person.assets ? Intl.NumberFormat().format(person.assets) : "-"}
          </td>
          <td className="pic"></td>
          <td className="action">
            {this.state.nomention ? (
              <Tooltip title="Denne personen ønsker ikke omtale">
                <div className="icon cancel" />
              </Tooltip>
            ) : (
              <Persontags Tags={person._tags} />
            )}
          </td>
          <td className="plus">
            <button onClick={e => this.props.onChange(person.id)}>
              <div className="icon plus"></div>
            </button>
          </td>
        </tr>
        {expanded}
      </React.Fragment>
    );
  }
}

export default Person;
